import { Card, Col, Container, FormControl, InputGroup, Modal, Row, Form as BSForm, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBroom, faPlusCircle, faSearch } from '@fortawesome/free-solid-svg-icons';
import { useEffect } from 'react';
import Loader from 'react-spinner-loader';
import { UserService } from '../../../../services/userService';
import { useState } from 'react';
import SigniteButton from '../../../ui-elements/signite-button/signiteButton';
import './userManagement.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import { UsersTable } from './user-listing-table/usersTable';
import { useQueryClient } from '@tanstack/react-query';
import { fetchData } from './userManagementUtils';
import { Formik } from 'formik';
import { getErrorClass, getErrorMessage } from '../../../../utils/errorUtils';
import { MultiSelect } from 'react-multi-select-component';

export const UserManagement = ({ currentUserRole }) => {
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [username, setUsername] = useState();
  const [userTableData, setUserTableData] = useState({ columns: [], data: [] });
  const queryClient = useQueryClient();

  const isAdmin = currentUserRole === "ADMIN";
  const isDataEntryTL = currentUserRole === "DATA_ENTRY_TL";

  const handleClose = (user, resetForm) => {
    let modifiedUser = {
      ...user,
      roles: user?.roles?.map((val) => val.value),
    };
    UserService.addUser(modifiedUser)
      .then((data) => {
        alert('User added successfully.');
        setShow(false);
        resetForm();
        queryClient.invalidateQueries(['data']);

      })
      .catch((err) => {
        console.error(err);
        alert(_.get(err, 'response.data.message', 'An error occured while adding users!'));
      });
  };
  const handleShow = () => setShow(true);

  const { columns, data } = userTableData;
  const initialValues = { roles: [] };
  const roles = [
    { label: 'Administrator', value: 'ADMIN' },
    { label: 'Business Development Executive', value: 'BUSINESS_DEV_EXE' },
    { label: 'Data Entry Team Lead', value: 'DATA_ENTRY_TL' },
    { label: 'Data Entry Executive', value: 'DATA_ENTRY_EXE' },
    { label: 'Data Entry Consultant', value: 'DE_CONSULTANT' }
  ];

  const triggerSearch = (searchName) => {
    setLoader(true);
    setUsername(searchName);
    fetchData({ pageIndex: 0, pageSize: 10, username: searchName, setLoader });
  };

  return (
    <Container fluid>
      <Formik
        enableReinitialize="true"
        initialValues={initialValues}
        onSubmit={async (data) => {
          console.log(data);
        }}
        validationSchema={null}
        isInitialValid={true}
      >
        {({ values, handleChange, handleBlur, errors, touched, setFieldValue, resetForm }) => {
          return (
            <>
              <Modal show={show} onHide={() => setShow(false)} size="lg">
                <Modal.Header closeButton>
                  <Modal.Title>Add User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <BSForm>
                    <Row>
                      {/* <BSForm.Group as={Col}>
                        <BSForm.Label>Username*</BSForm.Label>
                        <BSForm.Control
                          type="text"
                          name="username"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(errors, touched, 'username', true)}`}
                          value={values.username}
                          required
                        />
                        <span className="errorMessage">{getErrorMessage(errors, touched, 'username', true)}</span>
                      </BSForm.Group> */}
                      <BSForm.Group as={Col}>
                        <BSForm.Label>First Name*</BSForm.Label>
                        <BSForm.Control
                          type="text"
                          name="firstName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(errors, touched, 'firstName', true)}`}
                          value={values.firstName}
                          required
                        />
                        <span className="errorMessage">{getErrorMessage(errors, touched, 'firstName', true)}</span>
                      </BSForm.Group>
                      <BSForm.Group as={Col}>
                        <BSForm.Label>Middle Name</BSForm.Label>
                        <BSForm.Control
                          type="text"
                          name="middleName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(errors, touched, 'middleName', false)}`}
                          value={values.middleName}
                        />
                        <span className="errorMessage">{getErrorMessage(errors, touched, 'middleName', false)}</span>
                      </BSForm.Group>
                    </Row>
                    <Row>
                      <BSForm.Group as={Col}>
                        <BSForm.Label>Last Name*</BSForm.Label>
                        <BSForm.Control
                          type="text"
                          name="lastName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(errors, touched, 'lastName', true)}`}
                          value={values.lastName}
                          required
                        />
                        <span className="errorMessage">{getErrorMessage(errors, touched, 'lastName', true)}</span>
                      </BSForm.Group>
                      <BSForm.Group as={Col}>
                        <BSForm.Label>Email Id*</BSForm.Label>
                        <BSForm.Control
                          type="text"
                          name="emailId"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(errors, touched, 'emailId', true)}`}
                          value={values.emailId}
                          required
                        />
                        <span className="errorMessage">{getErrorMessage(errors, touched, 'emailId', true)}</span>
                      </BSForm.Group>
                      <BSForm.Group as={Col}>
                        <BSForm.Label>Phone Number*</BSForm.Label>
                        <BSForm.Control
                          type="text"
                          name="phoneNumber"
                          placeholder="+91123456789"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(errors, touched, 'phoneNumber', true)}`}
                          value={values.phoneNumber}
                          required
                        />
                        <span className="errorMessage">{getErrorMessage(errors, touched, 'phoneNumber', true)}</span>
                      </BSForm.Group>
                    </Row>
                    <Row>
                      <BSForm.Group as={Col}>
                        <BSForm.Label>Roles*</BSForm.Label>

                        <MultiSelect
                          options={roles}
                          value={values.roles || []}
                          onChange={(val) => {
                            setFieldValue('roles', val);
                          }}
                          labelledBy="Select"
                        />
                        <span className="errorMessage">{getErrorMessage(errors, touched, 'phoneNumber', true)}</span>
                      </BSForm.Group>
                    </Row>
                  </BSForm>
                </Modal.Body>
                <Modal.Footer>
                  <SigniteButton
                    variant={'primary'}
                    className=""
                    onClick={() => {
                      resetForm();
                      setShow(false);
                    }}
                  >
                    <FontAwesomeIcon icon={faBroom}></FontAwesomeIcon> Reset
                  </SigniteButton>
                  <SigniteButton
                    variant={'primary'}
                    className=""
                    onClick={() => {
                      handleClose(values, resetForm);
                    }}
                  >
                    <FontAwesomeIcon icon={faPlusCircle}></FontAwesomeIcon> Add User
                  </SigniteButton>
                </Modal.Footer>
              </Modal>
              <Loader show={loader} type="body" stack="vertical" message="Loading Data" />
              <Card>
                <Card.Header>
                  <Container>
                    <Row>
                      <Col md={6} lg={6}></Col>
                      <Col md={6} lg={6}>
                        <Row className="align-items-center">
                          <Col md={8} lg={8}>
                            <InputGroup>
                              <BSForm.Control
                                placeholder="Search By Name"
                                name="username"
                                value={values.username || ""}
                                onChange={(e) => {
                                  handleChange(e);
                                  if (e.target.value === "") {
                                    triggerSearch("");
                                  }
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    triggerSearch(values.username);
                                  }
                                }}
                              />
                              <Button
                                href="#"
                                className="attachedButton input-group-text"
                                variant="outline-secondary"
                                onClick={() => triggerSearch(values.username)}
                              >
                                <FontAwesomeIcon icon={faSearch} />
                              </Button>
                            </InputGroup>

                          </Col>
                          <Col md={4} lg={4} className="d-flex justify-content-end">
                            {isAdmin && (

                              <SigniteButton
                                variant="primary"
                                onClick={() => handleShow()}
                              >
                                <FontAwesomeIcon icon={faPlusCircle} /> Add User
                              </SigniteButton>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Container>

                </Card.Header>

                <Card.Body>
                  <QueryClientProvider client={queryClient}>
                    <UsersTable columns={columns} fetchData={fetchData} username={username} currentUserRole={currentUserRole} />
                  </QueryClientProvider>
                </Card.Body>
              </Card>
            </>
          );
        }}
      </Formik>
    </Container>
  );
};